
import React from "react";
import { Button, Row, Col } from "react-bootstrap";
import { ActionHandlerFunction, UserProfile } from "@preveil-api";
import { AdminUIActionTypes } from "src/common";
import { Icon } from "src/components";

type AllProps = {
  is_read_only?: boolean;
  user: UserProfile;
  is_approved?: boolean;
  handleAction?: ActionHandlerFunction;
}

// Description: Row showing the approver and their approval status
function ApproversRowComponent(props: AllProps) {
  const { is_read_only, user, is_approved, handleAction } = props;

  return <Row>
    <Col md={10} xs={8}>
      {!!user.name && <p className="semi-bold">{user.name}</p> }
      <p>{user.address}</p>
    </Col>
    {!is_read_only &&
      <Col md={2} xs={4} className="d-flex justify-content-end">
        {is_approved ? 
          <div className="approver-check">
            <Icon className="icon-check" />
          </div> : 
          <Button
            className="start-btn btn-sm"
            variant="outline-secondary"
            onClick={() => handleAction && handleAction({ actionType: AdminUIActionTypes.Start, params: { subsumeUser: user.address } })}
            >
            Start
          </Button>
        }
      </Col>
    }
  </Row>;
}

export default React.memo(ApproversRowComponent);
